module.exports = __webpack_public_path__ + "static/media/bakim.a18e84d4.jpg";